export const PROFILE = "PROFILE";
export const APP_INFO = "APP_INFO";
export const TRANSLATION = "TRANSLATION";
export const WITHDRAWAGAIN = "WITHDRAWAGAIN";
export const PAYMENT_SETTINGS="PAYMENT_SETTINGS"
